export default "__VITE_ASSET__TnsyVahb__"